import React, { Component, Fragment } from 'react';
import { isEmpty, size } from "lodash";
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { lighten } from '@mui/material/styles';

import Typography from '@mui/material/Typography';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';

import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';

import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Button } from '@mui/material';

export const headCells = [
    { id: 'spending_date', numeric: false, disablePadding: false, label: 'Créé le' },
    { id: 'spending_user', numeric: false, disablePadding: false, label: 'Utilisateur' },
    { id: 'spending_status', numeric: false, disablePadding: false, label: 'Statut' },
    { id: 'spending_category', numeric: false, disablePadding: false, label: 'Catégorie' },
    { id: 'spending_desc', numeric: false, disablePadding: false, label: 'Description' },
    { id: 'spending_supplier', numeric: false, disablePadding: false, label: 'Fournisseur' },
    { id: 'spending_labels', numeric: false, disablePadding: false, label: 'Labels' },
    { id: 'spending_project', numeric: false, disablePadding: false, label: 'Projet' },
    { id: 'spending_amount', numeric: true, disablePadding: false, label: 'Montant' },
    { id: 'spending_rest_to_pay', numeric: true, disablePadding: false, label: 'Reste à Payer' },
    { id: 'options', numeric: false, disablePadding: false, label: 'Options' },
  ];

export const EnhancedTableHead = (props) => {
    const { headers, onSelectAllClick, numSelected, rowCount } = props;

    const HEADS = headers || headCells
    return (
    <TableHead>
        <TableRow>
            <TableCell padding="checkbox">
            {onSelectAllClick &&
                <Checkbox
                    indeterminate={numSelected > 0 && numSelected < rowCount}
                    checked={numSelected === rowCount && rowCount > 0}
                    onChange={onSelectAllClick}
                    inputProps={{ 'aria-label': 'Selectionner tout' }}
                />
            }
            </TableCell>
            {HEADS.map(headCell => (
                <TableCell
                    key={headCell.id}
                    // align={headCell.numeric ? 'right' : 'left'}
                    padding={headCell.disablePadding ? 'none' : 'default'}
                >
                    {headCell.label}                
                </TableCell>
            ))}
        </TableRow>
    </TableHead>
    );
}

const useToolbarStyles = makeStyles(theme => ({
    root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    },
    highlight:
    theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
        },
    title: {
        flex: '1 1 100%',
    },
}));

export const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();
    const { numSelected, action, actionCollab, titleAction } = props;

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
            variant="dense"
        >
            {numSelected > 0 &&
                <Typography className={classes.title} color="inherit" variant="subtitle1">
                    {numSelected} selectioné{numSelected > 1 && "s"}
                </Typography>
            }

            {action && numSelected > 0 &&
                <Button 
                    title={titleAction || "Créer un paiement"} 
                    // variant="contained"
                    color="primary"
                    onClick={action}
                >
                    {titleAction || "Entrer un Paiement"}
                </Button>
            }
            {actionCollab && numSelected > 0 &&
                <Button 
                    title="Créer un paiement" 
                    // variant="contained"
                    color="primary"
                    onClick={actionCollab}
                >
                    Entrer un Paiement Collaborateur
                </Button>
            }
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};